<template>
  <div class="footer">
    {{ desc }}
  </div>
</template>
<script>
export default {
  props: {
    desc: {
      type: String,
      default: ''
    }
  }
}

</script>
<style lang="less" scoped>
@import "../../../../stylesheets/base/fn.less";
.footer {
  text-align: center;
  height: 21/@w;
  line-height: 21/@w;
  margin: 26/@w auto;
  font-family: PingFangSC-Regular;
  font-size: 15/@w;
  color: rgba(255, 255, 255, 0.5);
}
</style>
